/**
 * 动态路由状态
 */
export const routerstate: any = {
    // 动态路由
    routerItems: [],
}